'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListingContainer = require('./ListingContainer');

var _ListingContainer2 = _interopRequireDefault(_ListingContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ListingContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/index.js
// module id = 574
// module chunks = 0